"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _BufferState = require("@/libs/state/BufferState");
var _default = exports.default = {
  props: ['network'],
  data: function data() {
    return {
      sidebarOpen: false,
      page: 0,
      page_size: 200,
      search: '',
      last_updated: 0
    };
  },
  computed: {
    noResults() {
      return this.listState === 'updated' && this.filteredList.length === 0;
    },
    isLoading() {
      return this.listState === 'updating';
    },
    listState() {
      return this.network.channel_list_state;
    },
    list() {
      return this.network.channel_list || [];
    },
    filteredList() {
      let list = [];
      if (this.search.length <= 2) {
        list = this.list;
      } else {
        list = this.list.filter(channel => {
          let found = false;
          if (channel.channel.toLowerCase().indexOf(this.search) > -1) {
            found = true;
          }
          if (channel.topic.toLowerCase().indexOf(this.search) > -1) {
            found = true;
          }
          return found;
        });
      }
      return _lodash.default.sortBy(list, 'num_users').reverse();
    },
    paginated() {
      let offset = this.page * this.page_size;
      let list = this.filteredList;
      let channels = [];
      for (let i = offset; i < offset + this.page_size; i++) {
        if (list[i]) {
          channels.push(list[i]);
        }
      }
      return channels;
    },
    maxPages() {
      return Math.floor(this.filteredList.length / this.page_size);
    },
    canGoForward() {
      return this.page * this.page_size >= this.filteredList.length;
    },
    canGoBackward() {
      return this.page > 0;
    }
  },
  watch: {
    search() {
      this.page = 0;
    }
  },
  methods: {
    nextPage() {
      if (this.page < this.maxPages) {
        this.page++;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page--;
      }
    },
    maybeUpdateList() {
      this.network.maybeUpdateChannelList();
    },
    formatAndTrimTopic(rawTopic) {
      let showModes = this.$state.setting('showChanlistModes');
      let topic = showModes ? rawTopic : rawTopic.replace(/^\[([^\]]+)\] ?/, '');
      // Retire le bloc « netiquette » du réseau (Règles / Netiquette / + d'infos
      // + lien), comme pour les topics des salons rejoints (BufferState.set topic()).
      topic = (0, _BufferState.stripNetiquette)(topic);
      let blocks = (0, _MessageParser.default)(topic, {
        extras: false
      });
      let content = (0, _Html.default)(blocks);
      return content;
    },
    joinChannel(channelName) {
      let buffer = this.$state.getBufferByName(this.network.id, channelName);
      if (!buffer) {
        this.$state.addBuffer(this.network.id, channelName);
        this.network.ircClient.join(channelName);
      }
      // Toujours afficher le salon rejoint puis fermer la modal.
      this.$state.setActiveBuffer(this.network.id, channelName);
      this.$emit('close');
      // Sur mobile, la statebrowser (tiroir des salons) recouvre le chat et
      // reste ouverte derrière la modal : on la ferme pour révéler le salon
      // rejoint, comme le fait la sélection d'un salon existant
      // (StateBrowserNetwork.setActiveBuffer). Sans effet sur desktop.
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('statebrowser.hide');
        // Sur mobile, la liste des salons est affichée dans la sidebar :
        // on ferme aussi ce panneau pour révéler le salon rejoint.
        this.$state.$emit('sidebar.component', null);
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ChannelList"]
window._app_exports.components.ChannelList = exports.default ? exports.default : exports;
